import React, { Fragment } from "react";
import { Form, Row, Col } from "react-bootstrap";
import useValidation from "../../util/useValidation";
import {
  alphaNumericWithSpecialCharacterPattern,
  yearPattern
} from "../../constants/constants";
export const ClassXIIForm = ({
  qualificationTypeID,
  classXIIDetails,
  handleOnChangeQualificationDetails
}) => {
  const { handleOnBlurValidation, errors } = useValidation();
  const handOnBlurInput = e => {
    handleOnBlurValidation(e);
  };

  const currentClassXIIDetails = classXIIDetails[0] || {};
  const handleOnChangeClassXIIDetails = e => {
    handleOnChangeQualificationDetails(
      e,
      qualificationTypeID,
      currentClassXIIDetails
    );
  };
  return (
    <Fragment>
      <h6>Class XII Details / Intermediate</h6>
      <Form.Group as={Row} controlId="board">
        <Form.Label column sm={2}>
          Board/Authority*
        </Form.Label>
        <Col sm={10}>
          <Form.Control
            size="sm"
            required
            placeholder="Board/Authority"
            type="text"
            name="degree"
            value={currentClassXIIDetails.degree}
            onChange={handleOnChangeClassXIIDetails}
            onBlur={handOnBlurInput}
            isInvalid={errors.degree}
            pattern={alphaNumericWithSpecialCharacterPattern}
          />
          {errors.degree && (
            <Form.Control.Feedback type="invalid">
              {errors.degree.type === "required" &&
                "Board/Authority is required"}
              {errors.degree.type === "pattern" &&
                "Invalid characters entered for Board/Authority"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>
      <Form.Group as={Row} controlId="specialization">
        <Form.Label column sm={2}>
          Specialization*
        </Form.Label>
        <Col sm={10}>
          <Form.Control
            size="sm"
            required
            placeholder="Specialization"
            type="text"
            name="specialization"
            value={currentClassXIIDetails.specialization}
            onChange={handleOnChangeClassXIIDetails}
            onBlur={handOnBlurInput}
            isInvalid={errors.specialization}
            pattern={alphaNumericWithSpecialCharacterPattern}
          />
          {errors.specialization && (
            <Form.Control.Feedback type="invalid">
              {errors.specialization.type === "required" &&
                "Specialization is required"}
              {errors.specialization.type === "pattern" &&
                "Invalid characters entered for Specialization"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="yearGrade">
        <Form.Label column sm={2}>
          Completed Year*
        </Form.Label>
        <Col sm={4}>
          <Form.Control
            size="sm"
            placeholder="Year of Completion"
            type="text"
            name="completionYear"
            value={currentClassXIIDetails.completionYear}
            onChange={handleOnChangeClassXIIDetails}
            onBlur={handOnBlurInput}
            isInvalid={errors.completionYear}
            pattern={yearPattern}
            required
          />
          {errors.completionYear && (
            <Form.Control.Feedback type="invalid">
              {errors.completionYear.type === "required" &&
                "Completed Year is required"}
              {errors.completionYear.type === "pattern" &&
                "Please enter valid Year"}
            </Form.Control.Feedback>
          )}
        </Col>
        <Form.Label column sm={2} className="text-right">
          Percentage/Grade*
        </Form.Label>
        <Col sm={4}>
          <Form.Control
            size="sm"
            placeholder="Percentage / Grade"
            type="text"
            name="grade"
            value={currentClassXIIDetails.grade}
            onChange={handleOnChangeClassXIIDetails}
            onBlur={handOnBlurInput}
            isInvalid={errors.grade}
            pattern={alphaNumericWithSpecialCharacterPattern}
            required
          />
          {errors.grade && (
            <Form.Control.Feedback type="invalid">
              {errors.grade.type === "required" &&
                "Percentage/Grade is required"}
              {errors.grade.type === "pattern" &&
                "Please enter a valid Percentage/Grade "}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="college">
        <Form.Label column sm={2}>
          College/School*
        </Form.Label>
        <Col sm={10}>
          <Form.Control
            size="sm"
            required
            placeholder="College / School"
            type="text"
            name="college"
            value={currentClassXIIDetails.college}
            onChange={handleOnChangeClassXIIDetails}
            onBlur={handOnBlurInput}
            isInvalid={errors.college}
            pattern={alphaNumericWithSpecialCharacterPattern}
          />
          {errors.college && (
            <Form.Control.Feedback type="invalid">
              {errors.college.type === "required" &&
                "College/School is required"}
              {errors.college.type === "pattern" &&
                "Invalid characters entered for College/School"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="location">
        <Form.Label column sm={2}>
          Location*
        </Form.Label>
        <Col sm={10}>
          <Form.Control
            size="sm"
            required
            placeholder="Location"
            type="text"
            name="location"
            value={currentClassXIIDetails.location}
            onChange={handleOnChangeClassXIIDetails}
            onBlur={handOnBlurInput}
            isInvalid={errors.location}
            pattern={alphaNumericWithSpecialCharacterPattern}
          />
          {errors.location && (
            <Form.Control.Feedback type="invalid">
              {errors.location.type === "required" && "Location is required"}
              {errors.location.type === "pattern" &&
                "Invalid characters entered for Location"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>
    </Fragment>
  );
};
export default ClassXIIForm;
